import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormGroup } from '@angular/forms';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { Subject } from 'rxjs';
import { templatesOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { Role, Role_Data } from 'src/app/models/um/organization';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UmRoleMapUsersViewModalComponent } from '../um-role-map-users-view-modal/um-role-map-users-view-modal.component';

@Component({
  selector: 'app-um-role-view-modal',
  templateUrl: './um-role-view-modal.component.html',
  styleUrls: ['./um-role-view-modal.component.scss']
})
export class UmRoleViewModalComponent implements OnInit {

  formFields = {
    "code": { "type": "text", "required": true, "maxLength": 20, "pattern": null, "validationMessage": "Field is either empty or incorrect" },
    "name": { "type": "text", "required": true, "maxLength": 50, "pattern": null, "validationMessage": "Field is either empty or incorrect" },
    "description": { "type": "textarea", "required": false, "maxLength": 200, "pattern": null, "validationMessage": "Field is either empty or incorrect" },
    "template": { "type": "dropdown", "required": true, "pattern": null, "validationMessage": "Field is either empty or incorrect" }
  };
  operations;
  isView = false;
  viewId = null;
  templates = templatesOptionsConstant;
  isautocode: boolean = false;
  collapesedOrNot: boolean = false;
  collapesedOrNot3: boolean = false;
  collapesedOrNot2: boolean = false;
  collapesedOrNot1: boolean = false;
  roleForm: FormGroup;
  // selectAllGen: boolean = false;
  // selectAllIST: boolean = false;
  // selectAllEAP: boolean = false;
  // selectAllGrants: boolean = false;
 IsViewMode:boolean = false;
@Input() public Content: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  //role: Role;
  role: Role_Data;
  lstRoleGen: [];
  MappedUserRoles:any= [];
  constructor(
    private summaryService: UmSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private userService: UserService

  ) {

  }

  ngOnInit() {
    // this.IsAutoCodeConfigured();
    //this.setNewForm();
    this.roleForm = new FormGroup({
      Role_ID: new UntypedFormControl(null),
      Role_Name: new UntypedFormControl(null),
      Status: new UntypedFormControl(null),
      HasIST: new UntypedFormControl(null),
      HasEAP: new UntypedFormControl(null),
      HasGRANTS: new UntypedFormControl(null),
      HasAnalytics:new UntypedFormControl(null),
      lstGen: new UntypedFormControl([]),
      lstIST: new UntypedFormControl([]),
      lstEAP: new UntypedFormControl([]),
      lstGrants: new UntypedFormControl([]),
      lstAnalytics:new UntypedFormControl([]),
      IsDashboards:new UntypedFormControl(false),
      IsDashboardBuilder:new UntypedFormControl(false),
      IsSchedular:new UntypedFormControl(false),
      selectAllGen: new UntypedFormControl(false),
      selectAllIST: new UntypedFormControl(false),
      selectAllEAP: new UntypedFormControl(false),
      selectAllGrants: new UntypedFormControl(false),
      HasCME: new UntypedFormControl(null),
      HasCharity: new UntypedFormControl(null),
      HasSponsership: new UntypedFormControl(null),
      DashboardData: new UntypedFormControl([]),
      IstDisplayName: new UntypedFormControl(null),
      EapDisplayName: new UntypedFormControl(null),
      GrantsDisplayName: new UntypedFormControl(null),
    });

    let ID = null;
    if (this.Content.content && this.Content.content.id) {
      ID = this.Content.content.id;
    }// Edit mode
    this.summaryService.editRole(ID).subscribe((result) => {
      this.role = result;
      this.MappedUserRoles= [];
      this.MappedUserRoles=result["DashboardData"];
      this.roleForm.patchValue(result);
      this.CheckChangeGenSelectALL();
      this.CheckChangeISTSelectALL();
      this.CheckChangeEAPSelectALL();
      this.CheckChangGrantsSelectALL();
      this.checkAnalyticsDasboards();
      if (this.Content.heading === 'View'){
      this.IsViewMode=true;
     
      this.roleForm.controls['Status'].disable();
        setTimeout(() => {
          this.roleForm.disable({ emitEvent: false });
        }, 200);
      }
      
    })

    // }

    //  this.formFields = criteria.formFields;
    //  if (this.content && this.content.id && this.heading === 'Edit') { // Edit mode
    //    this.summaryService.getRoleSummary(this.content.id).subscribe((result) => {
    //      this.roleForm.patchValue(result);
    //    })
    //  } else if (this.content && this.content.id && this.heading === 'View') { //View mode 
    //    this.summaryService.getRoleSummary(this.content.id).subscribe((result) => {
    //      this.roleForm.patchValue(result);
    //      this.roleForm.disable();
    //    })
    //  }

   

  }

  checkAnalyticsDasboards()
  {
    this.roleForm.controls["IsDashboards"].setValue(false);
    this.roleForm.controls["IsDashboardBuilder"].setValue(false);
    this.roleForm.controls["IsSchedular"].setValue(false);
    this.roleForm.controls['lstAnalytics']?.value.forEach(element => {
      if (element.IsDashboards)
      {
         this.roleForm.controls["IsDashboards"].setValue(true);
      }
     
      if (element.IsDashboardBuilder)
      {
        this.roleForm.controls["IsDashboardBuilder"].setValue(true);
      }
      if (element.IsSchedular)
      {
        this.roleForm.controls["IsSchedular"].setValue(true);
      }

    });
  }
  Isdashboard(event){
  
    this.MappedUserRoles=[];

  }

  private setForm(result: Role_Data): void {
    this.roleForm = new UntypedFormGroup({
      Role_ID: new UntypedFormControl(result.Role_ID),
      Role_Name: new UntypedFormControl(result.Role_Name, [Validators.required, Validators.maxLength(25)]),
      Status: new UntypedFormControl(result.Status),
      HasIST: new UntypedFormControl(result.HasIST),
      HasEAP: new UntypedFormControl(result.HasEAP),
      HasGRANTS: new UntypedFormControl(result.HasGRANTS),
      HasAnalytics:new UntypedFormControl(result.HasAnalytics),
      lstGen: new UntypedFormControl(result.lstGen),
      lstIST: new UntypedFormControl(result.lstIST),
      lstEAP: new UntypedFormControl(result.lstEAP),
      lstGrants: new UntypedFormControl(result.lstGrants),
      HasCME: new UntypedFormControl(result.HasCME),
      HasCharity: new UntypedFormControl(result.HasCharity),
      HasSponsership: new UntypedFormControl(result.HasSponsership),
      lstAnalytics:new UntypedFormControl(result.lstAnalytics),
      IstDisplayName: new UntypedFormControl(result.IstDisplayName),
      EapDisplayName: new UntypedFormControl(result.EapDisplayName),
      GrantsDisplayName: new UntypedFormControl(result.GrantsDisplayName),
    });
  }

  private setNewForm(): void {
    this.roleForm = new UntypedFormGroup({
      Role_ID: new UntypedFormControl(null),
      Role_Name: new UntypedFormControl(null),
      Status: new UntypedFormControl(null),
      HasIST: new UntypedFormControl(null),
      HasEAP: new UntypedFormControl(null),
      HasGRANTS: new UntypedFormControl(null),
      HasAnalytics:new UntypedFormControl(null),
      lstGen: new UntypedFormControl([]),
      lstIST: new UntypedFormControl([]),
      lstEAP: new UntypedFormControl([]),
      lstGrants: new UntypedFormControl([]),
      HasCME: new UntypedFormControl(null),
      HasCharity: new UntypedFormControl(null),
      HasSponsership: new UntypedFormControl(null),
      lstAnalytics:new UntypedFormControl([]),
      IstDisplayName: new UntypedFormControl(null),
      EspDisplayName: new UntypedFormControl(null),
      GrantsDisplayName: new UntypedFormControl(null),

    });
  }

  save() {
    if (this.validateControls()) {
        if (this.roleForm.controls["IsDashboards"].value)
        {
           this.roleForm.controls['lstAnalytics']?.value.forEach(element => {
             if(element.Screen_Code=="626")
             {
              element.IsDashboards=true;
             }
           });
        }
        else{
          this.roleForm.controls['lstAnalytics']?.value.forEach(element => {
            if(element.Screen_Code=="626")
            {
             element.IsDashboards=false;
            }
          });
        }
        if (this.roleForm.controls["IsDashboardBuilder"].value)
        {
          this.roleForm.controls['lstAnalytics']?.value.forEach(element => {
            if(element.Screen_Code=="627")
            {
             element.IsDashboardBuilder=true;
            }
          });
        }
        else{
          this.roleForm.controls['lstAnalytics']?.value.forEach(element => {
            if(element.Screen_Code=="627")
            {
             element.IsDashboardBuilder=false;
            }
          });
        }
        if (this.roleForm.controls["IsSchedular"].value)
        {
          this.roleForm.controls['lstAnalytics']?.value.forEach(element => {
            if(element.Screen_Code=="628")
            {
             element.IsSchedular=true;
            }
          });
        }
        else{
          this.roleForm.controls['lstAnalytics']?.value.forEach(element => {
            if(element.Screen_Code=="628")
            {
             element.IsSchedular=false;
            }
          });
        }
  
      let roleName= this.roleForm.controls['Role_Name'].value;
      this.roleForm.controls["DashboardData"].setValue(this.MappedUserRoles);
      if (!this.Content.content && this.Content.heading === 'Add') {
        this.summaryService.addRole(this.roleForm.getRawValue()).subscribe(result => {
          if (result.Status === 0) {
            this.commonservice.SuccessBanner( "User Role " +roleName+ " added successfully");
            
            this.modalRef.close();
          }
          else {
            this.commonservice.ValidationBanner(result.Message);
          }
        })

      } else if (this.Content.content && this.Content.content.id && this.Content.heading === 'Edit') {
        this.summaryService.updateRole(this.roleForm.getRawValue()).subscribe(result => {
          if (result.Status === 0) {
            if(result.Message!=null && result.Message!=undefined && result.Message.length >0)
            {
              this.commonservice.SuccessBanner("User role " + roleName + " updated successfully however the analytics permissions will be made available shortly");
            }
            else{
              this.commonservice.SuccessBanner( "User Role " +roleName+ " Updated Successfully");
            }
            this.modalRef.close();
          }
          else {
            this.commonservice.ValidationBanner(result.Message);
          }
        })
      }

    }
  }
  GetDashboards()
  {
    // debugger;
    if(this.roleForm.controls["IsDashboards"].value)
    {
      let selectedIds = [];
    if (this.MappedUserRoles.length > 0) {
      selectedIds = this.MappedUserRoles.map(function (a) {
        return a.value;
      });
    }
    let modalRef = this.modalService.open(UmRoleMapUsersViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md modal-dialog-center',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { selectedIds: selectedIds }
    };
    modalRef.result.then((result) => {
      result.forEach((element) => {
        this.MappedUserRoles.push(element);
      });
    });
    }
  }
  
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.roleForm.value;

    // if (this.isautocode == false) {
    //   if (formData.CODE === null || formData.CODE === "") {
    //     $("#CODE").addClass("ng-touched ng-invalid validate-error");
    //     $("#CODE").removeClass("ng-untouched ng-valid");
    //     message += "Please enter Code.<br/>";
    //     isValid = false;
    //   } else {
    //     $("#CODE").addClass("ng-untouched ng-valid");
    //     $("#CODE").removeClass("ng-touched ng-invalid validate-error");
    //   }
    // }

    //if (formData.CODE === null || formData.CODE === "") {
    //  $("#CODE").addClass("ng-touched ng-invalid validate-error");
    //  $("#CODE").removeClass("ng-untouched ng-valid");
    //  message += "Please enter Code.<br/>";
    //  isValid = false;
    //} else {
    //  $("#CODE").addClass("ng-untouched ng-valid");
    //  $("#CODE").removeClass("ng-touched ng-invalid validate-error");
    //}

    if (formData.Role_Name === null || formData.Role_Name.trim() === "") {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter User Role <br/>";
      isValid = false;
    } else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }
    let HasOnePrevillage = false;
    if (this.roleForm.controls['lstGen']?.value.length > 0) {
      this.roleForm.controls['lstGen']?.value.filter(function (element: any) {

        if (element.HasView || element.HasAdd || element.HasManage || element.HasDelete || element.HasChangeOwner) {
          HasOnePrevillage = true;
        }
      });
    }
    if (this.roleForm.controls['lstIST']?.value.length > 0) {
      this.roleForm.controls['lstIST']?.value.filter(function (element: any) {
        if (element.HasView || element.HasAdd || element.HasManage || element.HasDelete || element.HasChangeOwner) {
          HasOnePrevillage = true;
        }
      });
    }
    if (this.roleForm.controls['lstEAP']?.value.length > 0) {
      this.roleForm.controls['lstEAP']?.value.filter(function (element: any) {
        if (element.HasView || element.HasAdd || element.HasManage || element.HasDelete || element.HasChangeOwner) {
          HasOnePrevillage = true;
        }
      });
    }
    if (this.roleForm.controls['lstGrants']?.value.length > 0) {
      this.roleForm.controls['lstGrants']?.value.filter(function (element: any) {
        if (element.HasView || element.HasAdd || element.HasManage || element.HasDelete || element.HasChangeOwner) {
          HasOnePrevillage = true;
        }
      });
    }
    if (this.roleForm.controls['IsDashboards'].value||this.roleForm.controls['IsDashboardBuilder'].value ||this.roleForm.controls['IsSchedular'].value) {
      {
          HasOnePrevillage = true;
      };
    }
    if(this.roleForm.controls['IsDashboards'].value){
        if(this.MappedUserRoles.length <= 0){
        message +="Please select at least one Dashboard <br/>";
      isValid = false;
      }
    }
    if (!HasOnePrevillage) {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      if(this.Content.heading=='Add'){
      message += "Please assign at least one permission to save the user role <br/>";
      }else{
        message += "Please provide at least one permission to the user role <br/>";
      }
      isValid = false;
    }

    if (!isValid)
    this.commonservice.ValidationBanner(message);
    return isValid;
  }

  SelectAllPrev(seldata: any, Scetion: any) {
   // let checkedRole = seldata.target.value;
    debugger;
   let selectAllGen= this.roleForm.controls['selectAllGen']?.value;
   let selectAllIST= this.roleForm.controls['selectAllIST']?.value
   let selectAllEAP= this.roleForm.controls['selectAllEAP']?.value
   let selectAllGrants= this.roleForm.controls['selectAllGrants']?.value

    if (Scetion == 'Gen') {
      if (this.roleForm.controls['lstGen']?.value.length > 0) {
        this.roleForm.controls['lstGen']?.value.forEach(element => {
          if (element.IsViewApp)
            element.HasView = selectAllGen;
          if (element.IsAddApp)
            element.HasAdd = selectAllGen;
          if (element.IsManageApp)
            element.HasManage = selectAllGen;
          if (element.IsDeleteApp)
            element.HasDelete = selectAllGen;
          if (element.IsChangeOwnerApp)
            element.HasChangeOwner = selectAllGen;
        });
      }
    }
    if (Scetion == 'IST') {
      if (this.roleForm.controls['lstIST']?.value.length > 0) {
        this.roleForm.controls['lstIST']?.value.forEach(element => {
          if (element.IsViewApp)
            element.HasView = selectAllIST;
          if (element.IsAddApp)
            element.HasAdd = selectAllIST;
          if (element.IsManageApp)
            element.HasManage = selectAllIST;
          if (element.IsDeleteApp)
            element.HasDelete = selectAllIST;
          if (element.IsChangeOwnerApp)
            element.HasChangeOwner = selectAllIST;
        });
      }
    }
    if (Scetion == 'EAP') {
      if (this.roleForm.controls['lstEAP']?.value.length > 0) {
        this.roleForm.controls['lstEAP']?.value.forEach(element => {
          if (element.IsViewApp)
            element.HasView = selectAllEAP;
          if (element.IsAddApp)
            element.HasAdd = selectAllEAP;
          if (element.IsManageApp)
            element.HasManage = selectAllEAP;
          if (element.IsDeleteApp)
            element.HasDelete = selectAllEAP;
          if (element.IsChangeOwnerApp)
            element.HasChangeOwner = selectAllEAP;
        });
      }
    }
    if (Scetion == 'Grants') {
      if (this.roleForm.controls['lstGrants']?.value.length > 0) {
        this.roleForm.controls['lstGrants']?.value.forEach(element => {
          if (element.IsViewApp)
            element.HasView = selectAllGrants;
          if (element.IsAddApp)
            element.HasAdd = selectAllGrants;
          if (element.IsManageApp)
            element.HasManage = selectAllGrants;
          if (element.IsDeleteApp)
            element.HasDelete = selectAllGrants;
          if (element.IsChangeOwnerApp)
            element.HasChangeOwner = selectAllGrants;
        });
      }
    }

  }
  Cancel(){
    this.modalRef.dismiss();
  }

  CheckChangeGenSelectALL(){
    let selectAllGen= true;   //
    if (this.roleForm.controls['lstGen']?.value.length > 0) {
      this.roleForm.controls['lstGen']?.value.forEach(element => {
        if (element.IsViewApp)
        if( !element.HasView){
          selectAllGen= false;}
        if (element.IsAddApp)
        if( !element.HasAdd){
          selectAllGen= false;}
        if (element.IsManageApp)
        if(!element.HasManage){
          selectAllGen= false;}
        if (element.IsDeleteApp)
        if(!element.HasDelete){
          selectAllGen= false;}
        if (element.IsChangeOwnerApp)
        if(!element.HasChangeOwner){
          selectAllGen= false;}
      });
      this.roleForm.controls['selectAllGen']?.setValue(selectAllGen);
    }
  }
  CheckChangeISTSelectALL(){
    let selectAllGen= true;   //
    if (this.roleForm.controls['lstIST']?.value.length > 0) {
      this.roleForm.controls['lstIST']?.value.forEach(element => {
        if (element.IsViewApp)
        if( !element.HasView){
          selectAllGen= false;}
        if (element.IsAddApp)
        if( !element.HasAdd){
          selectAllGen= false;}
        if (element.IsManageApp)
        if(!element.HasManage){
          selectAllGen= false;}
        if (element.IsDeleteApp)
        if(!element.HasDelete){
          selectAllGen= false;}
        if (element.IsChangeOwnerApp)
        if(!element.HasChangeOwner){
          selectAllGen= false;}
      });
      this.roleForm.controls['selectAllIST']?.setValue(selectAllGen);
    }
  }

  CheckChangeEAPSelectALL(){
    let selectAllGen= true;   //
    if (this.roleForm.controls['lstEAP']?.value.length > 0) {
      this.roleForm.controls['lstEAP']?.value.forEach(element => {
        if (element.IsViewApp)
        if( !element.HasView){
          selectAllGen= false;}
        if (element.IsAddApp)
        if( !element.HasAdd){
          selectAllGen= false;}
        if (element.IsManageApp)
        if(!element.HasManage){
          selectAllGen= false;}
        if (element.IsDeleteApp)
        if(!element.HasDelete){
          selectAllGen= false;}
        if (element.IsChangeOwnerApp)
        if(!element.HasChangeOwner){
          selectAllGen= false;}
      });
      this.roleForm.controls['selectAllEAP']?.setValue(selectAllGen);
    }
  }


  CheckChangGrantsSelectALL(){
    let selectAllGen= true;   //
    if (this.roleForm.controls['lstGrants']?.value.length > 0) {
      this.roleForm.controls['lstGrants']?.value.forEach(element => {
        if (element.IsViewApp)
        if( !element.HasView){
          selectAllGen= false;}
        if (element.IsAddApp)
        if( !element.HasAdd){
          selectAllGen= false;}
        if (element.IsManageApp)
        if(!element.HasManage){
          selectAllGen= false;}
        if (element.IsDeleteApp)
        if(!element.HasDelete){
          selectAllGen= false;}
        if (element.IsChangeOwnerApp)
        if(!element.HasChangeOwner){
          selectAllGen= false;}
      });
      this.roleForm.controls['selectAllGrants']?.setValue(selectAllGen);
    }
  }
  
  DeleteMappedRoles(role) {
    let index = this.MappedUserRoles.indexOf(role);
    this.MappedUserRoles.splice(index, 1);
  }

}
